import { Mail, Phone, MapPin, Facebook, Linkedin, MessageSquare } from 'lucide-react';

export const contacts = [
  {
    type: 'Email',
    value: 'pinoaisales@gmail.com',
    icon: Mail,
    href: 'mailto:pinoaisales@gmail.com'
  },
  {
    type: 'US Phone',
    value: '+1 510-557-5204',
    icon: Phone,
    href: 'tel:+15105575204'
  },
  {
    type: 'PH Mobile',
    value: '+63 915-4288-185',
    icon: Phone,
    href: 'tel:+639154288185'
  },
  {
    type: 'PH Landline',
    value: '+63 44 636 659',
    icon: Phone,
    href: 'tel:+6344636659'
  },
  {
    type: 'Address',
    value: 'San Leandro, California USA',
    icon: MapPin
  },
  {
    type: 'Address',
    value: 'San Leonardo, Nueva Ecija, Philippines',
    icon: MapPin
  }
];

export const socialLinks = [
  {
    name: 'Facebook',
    url: 'https://www.facebook.com/PinoAiWebDevelopmentServices',
    icon: Facebook
  },
  {
    name: 'LinkedIn',
    url: 'https://www.linkedin.com/in/jasper-roque-data-analyst-seo-webdesigner/',
    icon: Linkedin
  }
];

export const messageLinks = [
  {
    name: 'Facebook Messenger',
    url: 'https://m.me/jasperdroque',
    icon: MessageSquare
  },
  {
    name: 'Telegram',
    url: 'https://t.me/JasperRoque',
    icon: MessageSquare
  },
  {
    name: 'Slack',
    url: 'https://pino-aicom.slack.com/archives/C087YP66E2D',
    icon: MessageSquare
  }
];